/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import Pagination from 'components/atoms/pagination';
import Loader from 'components/atoms/loader';
import { ConcurrentsState } from 'store/modules/concurrents_store/types';

interface FollowupListConcurrentsProps {
  currentPageFollowup: number;
  setCurrentPageFollowup: React.Dispatch<React.SetStateAction<number>>;
}

const FollowupListConcurrents = (props: FollowupListConcurrentsProps) => {
  const { currentPageFollowup, setCurrentPageFollowup } = props;
  const { request } = useSelector<ApplicationState, MarketState>((state) => state.session.market);

  const { concurrents } = useSelector<ApplicationState, ConcurrentsState>(
    (state) => state.session.concurrents,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPageFollowup(currentPage);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <ul className="table-responsive" style={{ maxHeight: '400px' }}>
          {request?.get_provider_biddings?.loading ? (
            <Loader />
          ) : (
            <table className="table table-bordered table-striped">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">N.º CNL</th>
                  <th scope="col">Unidade Licitante</th>
                  <th scope="col">Edital</th>
                  <th scope="col">Cidade/Estado</th>
                </tr>
              </thead>
              <tbody>
                {concurrents?.followups?.map((licitacao) => (
                  <tr key={licitacao.id}>
                    <td className="text-center">
                      <a href={`/biddings/${licitacao.id}`} target="blank">
                        {licitacao.id}
                      </a>
                    </td>
                    <td>{licitacao.public_body.nome}</td>
                    <td>{licitacao.edital}</td>
                    <td className="text-center">
                      {licitacao.orgao_cidade}/{licitacao.orgao_estado}
                    </td>
                  </tr>
                ))}
                {concurrents?.followups?.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center border-0 pb-0">
                      <div className="alert alert-secondary m-0" role="alert">
                        <h4 className="alert-heading">Resultado não encontrado.</h4>
                        <p className="mb-0">
                          Não foram encontradas informações relacionadas a este CNPJ.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </ul>
        <div className="row d-print-none">
          <div className="col-md-12 px-4 mb-1">
            <Pagination
              postsPerPage={5}
              totalPosts={concurrents?.total_followup}
              paginate={paginate}
              currentPage={currentPageFollowup}
              firstAndLastPage
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowupListConcurrents;
